export const DS_CONFIG = {
  API: process.env.REACT_APP_API_URL || '',
  UI_URL: process.env.REACT_APP_UI_URL || '',
  COGNITO_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || '',
  COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
};
